export function normalizeString(str: string): string {
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  str = str.replace(/[^a-zA-Z0-9 ]/g, '');

  return str;
}
